module.exports = __webpack_public_path__ + "static/assets/d6f93c1ab186684ba10fa643d6a92fc2.svg";